// models/produtos/combos/ProdutoApresentacao.js
export class ProdutoApresentacao {
    constructor(id = 0, apresentacaoId = 0, produtoId, apresentacaoConjuntos = []) {
        this.id = id;
        this.apresentacaoId = apresentacaoId;
        this.produtoId = produtoId;
        this.apresentacaoConjuntos = apresentacaoConjuntos; //Lista de Conjuntos        
    }
}